// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"6d1a15a6","453":"f2455505"}[chunkId] + ".chunk.js";
};